export enum ListingBanner {
  HIDDEN = 'hidden',
  SOLD = 'sold',
  PENDING = 'pending',
  UNAVAILABLE = 'unavailable',
  OFFMARKET = 'off_market'
}
